import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dynamicLinkAddPageComponent from './dynamicLinkAddPage.component';

let dynamicLinkAddPageModule = angular.module('dynamicLinkAddPage', [
  uiRouter
])

.component('dynamicLinkAddPage', dynamicLinkAddPageComponent)

.name;

export default dynamicLinkAddPageModule;
